export default __webpack_public_path__ + "0fd334195bc373f0ebf06ab3feca1a5d.svg";